import React from 'react';
import './App.css';
import FormularioRetiro from './components/FormularioRetiro';

function App() {
  return (
    <div className="App">
      <FormularioRetiro />
    </div>
  );
}

export default App;